import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";

export const POST_USERS_START = "POST_USERS_START";
export const POST_USERS_SUCCESS = "POST_USERS_SUCCESS";
export const POST_USERS_ERROR = "POST_USERS_ERROR";

export const GET_USERS_START = "GET_USERS_START";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_ERROR = "GET_USERS_ERROR";

export const DELETE_USER_START = "DELETE_USER_START";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";

export const ENABLE_USER_START = "ENABLE_USER_START";
export const ENABLE_USER_SUCCESS = "ENABLE_USER_SUCCESS";
export const ENABLE_USER_ERROR = "ENABLE_USER_ERROR";

export const DISABLE_USER_START = "DISABLE_USER_START";
export const DISABLE_USER_SUCCESS = "DISABLE_USER_SUCCESS";
export const DISABLE_USER_ERROR = "DISABLE_USER_ERROR";

export const GET_CURRENT_USER_START = "GET_CURRENT_USER_START";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_ERROR = "GET_CURRENT_USER_ERROR";

export const CHANGE_PASSWORD_START = "CHANGE_PASSWORD_START";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const ENABLE_TWO_FACTOR_AUTH_START = "ENABLE_TWO_FACTOR_AUTH_START";
export const ENABLE_TWO_FACTOR_AUTH_SUCCESS = "ENABLE_TWO_FACTOR_AUTH_SUCCESS";
export const ENABLE_TWO_FACTOR_AUTH_ERROR = "ENABLE_TWO_FACTOR_AUTH_ERROR";

export const ENABLE_TWO_FACTOR_AUTH_CHECKBOX_START =
  "ENABLE_TWO_FACTOR_AUTH_CHECKBOX_START";
export const ENABLE_TWO_FACTOR_AUTH_CHECKBOX_SUCCESS =
  "ENABLE_TWO_FACTOR_AUTH_CHECKBOX_SUCCESS";
export const ENABLE_TWO_FACTOR_AUTH_CHECKBOX_ERROR =
  "ENABLE_TWO_FACTOR_AUTH_CHECKBOX_ERROR";

export const DISABLE_TWO_FACTOR_AUTH_CHECKBOX =
  "DISABLE_TWO_FACTOR_AUTH_CHECKBOX";

export const CHANGE_PROFILE_DATAS_START = "CHANGE_PROFILE_DATAS_START";
export const CHANGE_PROFILE_DATAS_SUCCESS = "CHANGE_PROFILE_DATAS_SUCCESS";
export const CHANGE_PROFILE_DATAS_ERROR = "CHANGE_PROFILE_DATAS_ERROR";

export const FORGOT_START = "FORGOT_START";
export const FORGOT_SUCCESS = "FORGOT_SUCCESS";
export const FORGOT_ERROR = "FORGOT_ERROR";

export const SET_PASSWORD_START = "SET_PASSWORD_START";
export const SET_PASSWORD_SUCCESS = "SET_PASSWORD_SUCCESS";
export const SET_PASSWORD_ERROR = "SET_PASSWORD_ERROR";

export const SET_USER_TABLE_FIELD = "SET_USER_TABLE_FIELD";

export const SET_AUTH = "SET_AUTH";

export const SET_USER_REMOVE_MODAL_OPEN = "SET_USER_REMOVE_MODAL_OPEN";
export const SET_USER_REMOVE_MODAL_CLOSE = "SET_USER_REMOVE_MODAL_CLOSE";

// Forms validation
const validateForm = {
  twoFactorAuth: (validate, fields, oneField) =>
    validate(fields, oneField)
      .prop("currentPassword", "Aktualne hasło")
      .required()
      .prop("token", "Token")
      .required()
      .getErrors().promise,
  changePassword: (validate, fields, oneField) =>
    validate(fields, oneField)
      .prop("currentPassword", "Aktualne hasło")
      .required()
      .prop("password", "Nowe hasło")
      .required()
      .simplePassword()
      .prop("passwordConfirm", "Powtórz nowe hasło")
      .required()
      .getErrors().promise,
  changeProfileDatas: (validate, fields, oneField) =>
    validate(fields, oneField)
      .prop("fullName", "Imię i nazwisko")
      .required()
      .getErrors().promise,
  forgot: (validate, fields, oneField) =>
    validate(fields, oneField)
      .prop("email", "Email")
      .required()
      .email()
      .getErrors().promise,
  setPassword: (validate, fields, oneField) =>
    validate(fields, oneField)
      .prop("password", "Hasło")
      .required()
      .simplePassword()
      .prop("passwordConfirm", "Powtórz hasło")
      .required()
      .getErrors().promise,
  createUser: (validate, fields, oneField) =>
    validate(fields, oneField)
      .prop("email", "Email")
      .required()
      .email()
      .getErrors().promise
};

const validatePasswordSame = {
  changePassword: (fields, msg) => {
    if (fields.password != fields.passwordConfirm) {
      let err = oneError(
        msg.forms.changePassword.errors.notTheSame,
        "password"
      );
      throw new ValidationErrors(err);
    }
  },
  setPassword: (fields, msg) => {
    if (fields.password != fields.passwordConfirm) {
      let err = oneError(msg.forms.setPassword.errors.notTheSame, "password");
      throw new ValidationErrors(err);
    }
  }
};

// Requests
const getUsersGet = (fetch, apiHost, accessToken) =>
  fetch(`${apiHost}/v1/users?limit=100&offset=0`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteUser = (fetch, apiHost, accessToken, uid, msg) =>
  fetch(`${apiHost}/v1/users/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {});
  });

const postUsers = (fetch, apiHost, accessToken, fields, msg) =>
  fetch(`${apiHost}/v1/users`, {
    body: JSON.stringify(fields),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: msg.forms.createUser.errors.emailTaken,
        field: "all"
      }
    });
  });

const getUsersMe = (fetch, apiHost, accessToken) =>
  fetch(`${apiHost}/v1/user/me`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchUsers = (fetch, apiHost, accessToken, uid, fields, msg) =>
  fetch(`${apiHost}/v1/users/${uid}`, {
    body: JSON.stringify(fields),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {
      currentPassword_wrong: {
        msg: msg.forms.changePassword.errors.currentPasswordWrong,
        field: "currentPassword"
      },
      "2fa_token_wrong": {
        msg: msg.forms.twoFactorAuth.errors.tokenWrong,
        field: "token"
      }
    });
  });

const putUsersGenerate2FA = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/users/${uid}/generate-2fa`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`
    },
    method: "PUT"
  }).then(response => {
    return validateResponse(response, {});
  });

const putUsersForgotPassword = (fetch, apiHost, fields, msg) =>
  fetch(`${apiHost}/v1/user/forgot-password`, {
    body: JSON.stringify(fields),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    method: "put"
  }).then(response => {
    return validateResponse(response, {
      email_wrong: {
        msg: msg.forms.forgot.errors.wrongEmail,
        field: "email"
      }
    });
  });

const patchChangePassword = (fetch, apiHost, fields, msg) =>
  fetch(`${apiHost}/v1/user/change-password`, {
    body: JSON.stringify(fields),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {
      token_wrong: {
        msg: msg.forms.setPassword.errors.wrongToken,
        field: "all"
      },
      token_expired: {
        msg: msg.forms.setPassword.errors.expiredToken,
        field: "all"
      }
    });
  });

// Actions
export function getUsers() {
  return ({ fetch, validate, config, users, msg }) => ({
    type: "GET_USERS",
    payload: {
      promise: getUsersGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function createUser(fields) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: "POST_USERS",
    payload: {
      promise: validateForm["createUser"](validate, fields)
        .then(() =>
          postUsers(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            fields,
            msg().users
          )
        )
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeUser(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: "DELETE_USER",
    payload: {
      promise: deleteUser(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        msg().users
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function getCurrentUser() {
  return ({ fetch, validate, config, users }) => ({
    type: "GET_CURRENT_USER",
    payload: {
      promise: getUsersMe(
        fetch,
        config().apiHost,
        users().viewer.accessToken
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    },
    data: { fetch, validate, config, users }
  });
}

export function changePassword(fields) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: "CHANGE_PASSWORD",
    payload: {
      promise: validateForm["changePassword"](validate, fields)
        .then(() => validatePasswordSame["changePassword"](fields, msg().users))
        .then(() =>
          patchUsers(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            users().currentUser.uid,
            fields,
            msg().users
          )
        )
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function changeProfileDatas(fields) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: "CHANGE_PROFILE_DATAS",
    payload: {
      promise: patchUsers(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        users().currentUser.uid,
        fields,
        msg().users
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function changeAvatar(fields) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: "CHANGE_AVATAR",
    payload: {
      promise: patchUsers(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        users().currentUser.uid,
        fields,
        msg().users
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function enableTwoFactorAuthCheckbox(viewer, currentUser) {
  return ({ fetch, validate, config, users }) => ({
    type: "ENABLE_TWO_FACTOR_AUTH_CHECKBOX",
    payload: {
      promise: putUsersGenerate2FA(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        users().currentUser.uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function disableTwoFactorAuthCheckbox() {
  return {
    type: DISABLE_TWO_FACTOR_AUTH_CHECKBOX
  };
}

export function enableTwoFactorAuth(fields, viewer, currentUser) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: "ENABLE_TWO_FACTOR_AUTH",
    payload: {
      promise: validateForm["twoFactorAuth"](validate, fields)
        .then(() =>
          patchUsers(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            users().currentUser.uid,
            fields,
            msg().users
          )
        )
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function enableUser(fields, uid) {
  fields.active = true;
  return ({ fetch, validate, config, users, msg }) => ({
    type: "ENABLE_USER",
    payload: {
      promise: patchUsers(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        fields,
        msg().users
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function disableUser(fields, uid) {
  fields.active = false;
  return ({ fetch, validate, config, users, msg }) => ({
    type: "DISABLE_USER",
    payload: {
      promise: patchUsers(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        fields,
        msg().users
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function forgot(fields) {
  return ({ fetch, validate, config, msg }) => ({
    type: "FORGOT",
    payload: {
      promise: validateForm["forgot"](validate, fields)
        .then(() =>
          putUsersForgotPassword(fetch, config().apiHost, fields, msg().users)
        )
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function setPassword(fields, token) {
  fields = fields.set("token", token);
  return ({ fetch, validate, config, msg }) => ({
    type: "SET_PASSWORD",
    payload: {
      promise: validateForm["setPassword"](validate, fields)
        .then(() => validatePasswordSame["setPassword"](fields, msg().users))
        .then(() =>
          patchChangePassword(fetch, config().apiHost, fields, msg().users)
        )
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function setUserTableField(name, value) {
  return {
    type: SET_USER_TABLE_FIELD,
    payload: {
      name,
      value
    }
  };
}

export function setAuth(auth) {
  return {
    type: SET_AUTH,
    payload: {
      auth
    }
  };
}

export function openRemoveUserModal(uidToRemove) {
  return {
    type: SET_USER_REMOVE_MODAL_OPEN,
    payload: {
      uidToRemove
    }
  };
}

export function closeRemoveUserModal() {
  return {
    type: SET_USER_REMOVE_MODAL_CLOSE
  };
}

// Standard functions
export function validateFormFieldUsers(form, name, value) {
  const feature = "users";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/users/actions.js